import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import VueAxios from "vue-axios";
import VueToast from "vue-toast-notification";
import refreshTokenInterceptor from "./refreshTokenInterceptor";
import { BVToastPlugin } from "bootstrap-vue";

axios.defaults.withCredentials = true;
axios.defaults.baseURL = "/api";
axios.interceptors.request.use(config => {
  return config;
});

axios.interceptors.response.use(response => response, refreshTokenInterceptor);
axios.interceptors.response.use(
  response => response,
  error => {
    switch (error.response.status) {
      case 403:
        Vue.$toast.warning(error.response.data.message);
        break;
      case 400:
        if (Array.isArray(error.response.data.message)) {
          error.response.data.message.forEach(message => {
            Vue.$toast.warning(message);
          });
        } else {
          Vue.$toast.warning(error.response.data.message);
        }
        break;
      case 500:
        Vue.$toast.error("Whoops something went wrong.");
        break;
      case 422:
        break;
      default:
        Vue.$toast.warning(error.response.data.message);
    }
    throw error;
  }
);

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth === true) {
    store.state.auth.isAuthenticated === true ? next() : next("login");
  } else {
    next();
  }
});

Vue.use(VueAxios, axios);
Vue.config.productionTip = false;
import { PopoverPlugin } from "bootstrap-vue";
Vue.use(PopoverPlugin);

Vue.use(VueToast, {
  position: "top-right",
  duration: 10000
});

Vue.use(BVToastPlugin);
import { ModalPlugin } from "bootstrap-vue";
Vue.use(ModalPlugin);

import { CollapsePlugin } from "bootstrap-vue";
Vue.use(CollapsePlugin);

Vue.use({
  install(Vue) {
    Vue.prototype.$gettext = function(string) {
      return string;
    };
  }
});

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "./assets/scss/paper-dashboard.scss";
import "./assets/scss/custom.scss";
import "vue-toast-notification/dist/theme-sugar.css";

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
